import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";

function LinearProgressBar(props) {
  const { percentage, showPercentageText, wrapperStyle } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "14px",
        ...wrapperStyle,
      }}
    >
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: "6px",
          borderRadius: "50px",
          width: "100%",
          backgroundColor: "rgba(47, 43, 61, 0.08)",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "rgba(70, 160, 145, 1)",
          },
        }}
      />
      {showPercentageText && (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "600",
            color: "rgba(47, 43, 61, 0.7)",
          }}
        >
          {percentage}%
        </Typography>
      )}
    </Box>
  );
}

export default LinearProgressBar;
